<script setup>
import Select from "./Select.vue";
import InputWithUnit from "../InputWithUnit.vue";

const props = defineProps(['id', 'label', 'options', 'subattributes'])
const shortSide = defineModel('short-side')
const longSide = defineModel('long-side')
const value = defineModel('value')
</script>

<template>
    <fieldset class="field field--sides">
        <legend class="screen-reader-text">Side sizes</legend>
        <InputWithUnit :id="`attribute-${id}-${subattributes['long-side'].id}`" :label="subattributes['long-side'].label" :min="subattributes['long-side'].min" :step="subattributes['long-side'].step" :max="subattributes['long-side'].max" :unit="subattributes['long-side'].unit" :placeholder="subattributes['long-side'].placeholder" v-model="longSide" />
        <InputWithUnit :id="`attribute-${id}-${subattributes['short-side'].id}`" :label="subattributes['short-side'].label" :min="subattributes['short-side'].min" :step="subattributes['short-side'].step" :max="subattributes['short-side'].max" :unit="subattributes['short-side'].unit" :placeholder="subattributes['short-side'].placeholder" v-model="shortSide" />
    </fieldset>

    <Select :id="id" :label="label" :options="options" v-model="value" />
</template>
